var components
try {
  components = {
    uPopup: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-popup/u-popup" */ "uview-ui/components/u-popup/u-popup.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = _vm.info.orderImages && _vm.info.orderImages.length
  var g1 =
    _vm.info.commentStatus === 1
      ? _vm.info.commentImages && _vm.info.commentImages.length
      : null
  var g2 = _vm.info.refundInfo
    ? ((_vm.info.refundInfo.refundAmount || 0) / 100).toFixed(2)
    : null
  var l0 = _vm.info.detailList
    ? _vm.__map(_vm.info.detailList, function (goods, __i0__) {
        var $orig = _vm.__get_orig(goods)
        var g3 = ((goods.subtotal || 0) / 100).toFixed(2)
        return {
          $orig: $orig,
          g3: g3,
        }
      })
    : null
  var g4 = _vm.info.detailList
    ? ((_vm.info.declaredAmount || 0) / 100).toFixed(2)
    : null
  var g5 = _vm.info.detailList
    ? ((_vm.info.declaredFee || 0) / 100).toFixed(2)
    : null
  var g6 = _vm.info.detailList
    ? ((_vm.info.actualPayAmount || 0) / 100).toFixed(2)
    : null
  var g7 =
    _vm.info.overdueStatus !== 0 &&
    _vm.info.overdueStatus !== 2 &&
    _vm.info.overdueStatus === 1
      ? ((_vm.info.overdueFee || 0) / 100).toFixed(2)
      : null
  var g8 =
    _vm.info.overdueStatus !== 0 &&
    _vm.info.overdueStatus !== 2 &&
    _vm.info.overdueStatus === 3
      ? ((_vm.info.overdueFee || 0) / 100).toFixed(2)
      : null
  var g9 =
    _vm.info.overdueStatus !== 0 &&
    _vm.info.overdueStatus !== 2 &&
    _vm.info.overdueStatus === 4
      ? ((_vm.info.overdueFee || 0) / 100).toFixed(2)
      : null
  var g10 = [1, 4].includes(_vm.info.status) && _vm.info.takeShopId
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.showCancel = false
      _vm.currentOrder = null
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        g1: g1,
        g2: g2,
        l0: l0,
        g4: g4,
        g5: g5,
        g6: g6,
        g7: g7,
        g8: g8,
        g9: g9,
        g10: g10,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }